import { ref, watch, computed } from '@vue/composition-api'

export default function useCommitmentHandler(props, emit) {
  // ------------------------------------------------
  // commitmentLocal
  // ------------------------------------------------

  const commitmentLocal = ref(JSON.parse(JSON.stringify(props.commitment.value)))
  
  const resetCommitmentLocal = () => {
    commitmentLocal.value = JSON.parse(JSON.stringify(props.commitment.value))
  }
  const uniqueModalId = ref('modal-' + Math.random().toString(36).slice(2, 11))

  watch(props.commitment, () => {
    resetCommitmentLocal()
  })

  const behaviourReformatted = computed(() => commitmentLocal.value.behaviour.name?.replace(/<[^>]*>/g, ''))

  const onSubmit = () => {
    const commitmentData = JSON.parse(JSON.stringify(commitmentLocal))

    // Emit event for add/update commitment
    if (props.commitment.value._id || props.commitmentIndex.value !== -1) {
      emit('update-commitment', commitmentData.value, props.commitmentIndex.value)
    } else {
      emit('add-commitment', commitmentData.value)
    }

    // Close sidebar
    emit('update:is-commitment-handler-sidebar-active', false)
  }

  const changeCommitmentStatus = () => {   
    commitmentLocal.value = {
      ...commitmentLocal.value,
      completed: !commitmentLocal.value.completed
    }
  }

  return {
    commitmentLocal,
    resetCommitmentLocal,
    changeCommitmentStatus,
    uniqueModalId,

    // UI
    onSubmit,
    behaviourReformatted,
  }
}
